import React, {useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import PlayerProfile from './PlayerProfile'
import DisplayPlayerProfile from './DisplayPlayerProfile'
import PlayerAccountInfo from './PlayerAccountInfo'
import PlayerEventList from './PlayerEventList'
import GamesByPlayerId from '../games/GamesByPlayerId'
import GameCountByPlayerId from '../games/GameCountByPlayerId'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import axios from 'axios'

//https://spin.atomicobject.com/2019/10/01/a-quick-start-guide-to-query-strings-with-react-router/
//https://ui.dev/react-router-v5-query-strings
//https://ultimatecourses.com/blog/query-strings-search-params-react-router
export default function PlayerDetails({ match }) {
    const [token, setToken] = useState();
    const [appData, setAppData] = useState([]);
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState();
    const [playerId, setPlayerId] = useState();
    const [userRole, setUserRole] = useState("");
    const { search } = useLocation()
    const values = queryString.parse(search)
    const [idType, setIdType] = useState(values.idtype);
    const [id, setId] = useState(values.id);

    const [player, setPlayer] = useState();
    const apiPath = '/api/ChessPlayers/GetPlayerByID?id=' + id + '&idType=' + idType;
        
    useEffect(async () => {
        setAuthenticated(await authService.isAuthenticated());
        var user = await authService.getUser();
        if (user != null) {
            var role = user.role;
            setUserName(user.sub);
            if (user.sub.includes("FIDE")) {
                setIsPlayer(true);
            } else if (user.sub.includes("Affiliate")) {
                setIsPlayer(false);
                setIsOrganizer(true);
            }
            else if (user.sub.includes("USCF")) {
                setIsPlayer(true);
            }
            setUserRole(role);
            if (role.includes("Administrators"))
                setIsAdmin(true);
        }

        setToken(await authService.getAccessToken());
        var ttt = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${ttt}` }
        }
        axios.get(apiPath, headers).then((response) => {
            setPlayer(response.data);
        }).catch((error) => {
            console.log(JSON.stringify(error));
        });
    }, []);

    return (
        <div>
            {player &&
                <div>
                    <DisplayPlayerProfile player={player} />
                    {/*<PlayerEventList playerFideID={player.fidePlayerId} />*/}
                    {isAdmin &&
                        <PlayerAccountInfo idType={player.fidePlayerId > 0 ? "FIDE" : "USCF"} id={player.fidePlayerId > 0 ? player.fidePlayerId : player.uscfPlayerId} />
                    }
                    {!authenticated &&
                        <GameCountByPlayerId idType={player.fidePlayerId > 0 ? "FIDE" : "USCF"} id={player.fidePlayerId > 0 ? player.fidePlayerId : player.uscfPlayerId} />
                    }
                    {authenticated &&
                        <GamesByPlayerId idType={player.fidePlayerId > 0 ? "FIDE" : "USCF"} id={player.fidePlayerId > 0 ? player.fidePlayerId : player.uscfPlayerId} />
                    }
            </div>
            }    
        </div>
    )
}
